var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPodcasts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "22px",
    viewBox: "0 0 13 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSketch: "http://www.bohemiancoding.com/sketch/ns",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    sketchType: "MSPage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "screens/review",
    sketchType: "MSArtboardGroup",
    transform: "translate(-720.000000, -33.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    sketchType: "MSLayerGroup",
    transform: "translate(47.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "podcast",
    transform: "translate(651.000000, 23.000000)",
    sketchType: "MSShapeGroup"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0045139,10.1209821 L22,10.7888393 C22.0045139,14.0102679 24.0763889,16.7111607 26.8795139,17.4772321 C26.9381944,17.4821429 26.996875,17.5017857 27.0510417,17.5214286 C27.3173611,17.6196429 27.5069444,17.8602679 27.5972222,18.15 L27.5972222,21.0325893 C27.5972222,21.5678571 27.9989583,22 28.5,22 L28.5045139,22 C29.0055556,22 29.4027778,21.5678571 29.4027778,21.0325893 L29.4027778,18.1450893 C29.4930556,17.8553571 29.678125,17.6196429 29.9444444,17.5214286 C29.9986111,17.5017857 30.0572917,17.4821429 30.1204861,17.4772321 C32.9236111,16.7111607 35,14.0102679 35,10.7888393 L35,10.1209821 C35,9.61026786 34.5982639,9.19285714 34.1197917,9.19285714 C33.6413194,9.19285714 33.2395833,9.60535714 33.2395833,10.1209821 L33.2395833,10.7888393 C33.2395833,12.1883929 32.7204861,13.4455357 31.8583333,14.3638393 C30.9916667,15.2772321 29.8135417,15.846875 28.4954861,15.846875 C27.1774306,15.846875 26.0083333,15.2821429 25.1461806,14.3638393 C24.2840278,13.4455357 23.7604167,12.1834821 23.7604167,10.7888393 L23.7604167,10.1209821 C23.7604167,9.61026786 23.3631944,9.19285714 22.8802083,9.19285714 C22.4017361,9.19285714 22.0045139,9.61026786 22.0045139,10.1209821 Z M25.0243056,3.71741071 L25.0243056,10.7790179 C25.0243056,12.8316964 26.590625,14.4964286 28.5225694,14.4964286 C30.4545139,14.4964286 32.0208333,12.8316964 32.0208333,10.7790179 L32.0208333,3.71741071 C32.0208333,1.66473214 30.4545139,0 28.5225694,0 C26.590625,0 25.0243056,1.66473214 25.0243056,3.71741071 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcasts);
export default __webpack_public_path__ + "static/media/podcasts.0ea1423d826dcb83fd0c35e961301892.svg";
export { ForwardRef as ReactComponent };